// extracted by mini-css-extract-plugin
module.exports = {"root":"icon-area_root__Zgup4","imagesWrapper":"icon-area_imagesWrapper__bn9og","imageContainer":"icon-area_imageContainer__uAEUb"};